var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('sidebar'),_c('navbar'),_c('v-content',[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1),_c('v-footer',{attrs:{"app":"","fixed":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }